import React, { createContext, useState } from 'react';
import Layout from './components/layout/Layout.js';
import ErrorFallback from './components/common/ErrorFallback.jsx';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './assets/scss/core/_global.scss';
if (process.env.REACT_APP_EMBED_SITE == 1) {
  require('./assets/scss/components/chillblast/overrides.scss');
}
else if (process.env.REACT_APP_EMBED_SITE == 2) {
  require('./assets/scss/components/ccl/overrides.scss');
}

//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { solid, regular, brands, icon } from '@fortawesome/fontawesome-svg-core/import.macro'
//<FontAwesomeIcon icon={solid('user-secret')} />
//<FontAwesomeIcon icon={regular('coffee')} />
//<FontAwesomeIcon icon={icon({name: 'coffee', style: 'solid'})} />
//<FontAwesomeIcon icon={brands('twitter')} />

export const EmbedSiteShortContext = createContext(null);

export default function App ()
{ 
    const [resetKey, setResetKey] = useState(0);

    let site = "";

    if (process.env.REACT_APP_EMBED_SITE == 1) 
    {
        site = "chillblast";
    }
    else if (process.env.REACT_APP_EMBED_SITE == 2) 
    {
        site = "ccl";
    }

    // handle when user closes error
    const resetError = () =>
    {
        setResetKey(prevKey => prevKey + 1);
    }

    return (
        <>
            <EmbedSiteShortContext.Provider value={site}>
                <QueryClientProvider client={new QueryClient()}>
                    <div id="configuratorRoot" className={site}>
                        <ErrorBoundary FallbackComponent={ErrorFallback} onReset={resetError}>
                            <Layout key={resetKey} />
                        </ErrorBoundary>
                    </div>
                    <ReactQueryDevtools initialIsOpen={false} />
                </QueryClientProvider>
            </EmbedSiteShortContext.Provider>
        </>
    );
}
